import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight, FaAngleRight } from "react-icons/fa";
import ModalV3 from '../shared/Modal/ModalV3';
import { useScheduleCallMutation } from "services/clientApi";
import { toast } from "react-toastify";
import moment from "moment";
import "./HomeClientNew.scss";
import { useNavigate } from "react-router-dom";

const dayLabels = ["M", "T", "W", "T", "F", "S", "S"];

export default function Calendar() {
  const navigate = useNavigate();
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [openScheduleAppointment, setOpenScheduleAppointment] = useState(false);
  const [schedule] = useScheduleCallMutation();
  const [data, setData] = useState({
    title: null,
    start_date: null,
    description: null,
  });

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const startOfMonth = new Date(year, month, 1);
  const endOfMonth = new Date(year, month + 1, 0);
  const startDay = (startOfMonth.getDay() + 6) % 7;

  const daysInMonth = Array.from({ length: endOfMonth.getDate() }, (_, i) => i + 1);
  const paddedDays = [...Array(startDay).fill(""), ...daysInMonth];
  const monthLabel = currentDate.toLocaleString("en-GB", { month: "short" }).toUpperCase();

  const isToday = (day) =>
    day === today.getDate() &&
    month === today.getMonth() &&
    year === today.getFullYear();

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const handleSumbit = async (e) => {
    e.preventDefault();

    if (!data.description || !data.start_date || !data.title)
      return toast.warn('Please fil in all the fields.')

    const result = await schedule({
      start_date: moment(data.start_date).format("YYYY-MM-DD HH:mm:ss"),
      title: data.title,
      description: data.description,
    });

    if ("error" in result) {
      console.log("errror");
    } else {
      toast.success("Appointment was reserved successfully. We will get in touch soon!");
    }
    setOpenScheduleAppointment(false)
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };


  return (
    <div className="calendar-container p-3">
      <h5 className="mb-4">Calendar</h5>

      <div className="calendar-box mb-3">
        <div className="calendar-header">
          <div className="calendar-left" />
          <div className="calendar-right">
            <FaChevronLeft size={12} onClick={handlePrevMonth} />
            <span className="calendar-title">{monthLabel} {year}</span>
            <FaChevronRight size={12} onClick={handleNextMonth} />
          </div>
        </div>

        <div className="calendar-grid" style={{ backgroundColor: "#1E266D50" }}>
          {dayLabels.map((day, i) => (
            <div className="fw-semibold text-muted small" key={i}>{day}</div>
          ))}
        </div>

        <div className="calendar-grid">
          {paddedDays.map((date, i) => (
            <div key={i} className={`date-cell ${isToday(date) ? "today" : ""}`}>
              {date && <span className="circle-inner">{date}</span>}
            </div>
          ))}
        </div>
      </div>

      <div className='homeLinks mt-auto mt-5'>
        {/* <a onClick={() => setOpenScheduleAppointment(true)} style={{ cursor: "pointer" }} > */}
        <div className="mt-5 p-2"></div>
        <a onClick={() => navigate('/request-appointment')} style={{ cursor: "pointer" }} >
          REQUEST AN APPOINTMENT <FaAngleRight />
        </a>
        {/* {openScheduleAppointment && (
          <ModalV3
            isOpen={openScheduleAppointment}
            onClose={() => setOpenScheduleAppointment(false)}
          // disableManualClose={true}
          >
            <div className="d-flex align-items-center justify-content-center mt-5 gap-4">
              <i
                className="fa-solid fa-calendar-check color-secondary-ub"
                style={{ fontSize: "60px" }}
              />
              <h4 className="color-primary-ub mb-0" style={{ fontSize: "28px", fontWeight: 600 }}>
                Schedule an appointment
              </h4>
            </div>

            <p className="w-100 m-auto text-grey mt-4">Fill the form to schedule a personalized appointment with one of our experts to discuss your needs and explore the best solutions tailored just for you.</p>

            <div className={`w-100`}>
              <form className="">
                <div className="form-group w-100 m-auto mt-4 text-start">
                  <label className="fw-bold color-primary-ub mb-1">Appointment topic*</label>

                  <input
                    name="title"
                    onChange={handleChange}
                    type="title"
                    className="form-control border bg-white"
                  />
                </div>

                <div className="form-group w-100 m-auto mt-4 text-start ">
                  <label className="fw-bold color-primary-ub mb-1">Select your available date and hour*</label>

                  <input
                    onChange={handleChange}
                    name="start_date"
                    type="datetime-local"
                    min={new Date().toISOString().slice(0, 16)}
                    className="form-control border bg-white"
                  />
                </div>
                <div className="form-group w-100 m-auto mt-4 text-start">
                  <label className="fw-bold color-primary-ub mb-1">Additional Details*</label>
                  <textarea
                    onChange={handleChange}
                    type="text"
                    name="description"
                    className="form-control border bg-white"
                  />
                </div>
                <div className="text-center w-100 my-5">
                  <button
                    onClick={handleSumbit}
                    className="btn btn-primary btn-lg w-100"
                  >
                    Reserve appointment
                  </button>
                </div>
              </form>
            </div>
          </ModalV3>
        )} */}
      </div>
    </div>
  );
}
